import { render, staticRenderFns } from "./EducationEdit.vue?vue&type=template&id=3c4113ed&"
import script from "./EducationEdit.vue?vue&type=script&lang=js&"
export * from "./EducationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports